// const preUrl = url => {
//   return localStorage.getItem('preUrl') + url
// }
const zyurl = url => {
  return localStorage.getItem('zyUrl') + '/api' + url
}
// const cpurl = url => {
//   return localStorage.getItem('cpUrl') + '/api' + url
// }

export default function() {
  return {
    writeLog: window.ConfigNew.opUrl + '/Push/WriteLog', // 埋点

    // login
    getCfg: window.ConfigNew.preUrl, // 获取配置
    readToken: zyurl('/accounts/readToken'), // 读取token中的信息 - 一键登录用
    // getRegInfo: window.ConfigNew.preUrl + '/PreLanding/getRegInfo',
    // preLogin: preUrl('/PreLanding/preLogin'), // 预登陆
    // tpreLogin: preUrl('/PreLanding/teacherPreLogin'), // 教师预登陆
    // hpreLogin: preUrl('/PreLanding/headmasterPreLogin'), // 校长预登陆
    post: zyurl('/postAssessment/post'),
    login: zyurl('/menus/unifyLogin'), // 登录
    fpSendMsg: zyurl('/FrontendStudents/sendMessageOfPassword'), // 找回密码 - 获取验证码
    fpGetVerify: zyurl('/FrontendStudents/verifyNum'), // 找回密码 - 校验验证码
    fpResetPwd: zyurl('/FrontendStudents/getBackPassword'), // 找回密码 - 重置密码
    activation: zyurl('/studentAccount/activation'), // VIP激活
    getSchoolByCountryIdStu: zyurl('/schools/getSchoolListByCountryIdStu'), // 获取学校
    getGradeBySchoolIdNoCount: zyurl('/categorys/getGradeListBySchoolIdNoCount'), // 获取年级
    getClassByCategoryId: zyurl('/category_classlists/getClassByCategoryId'), // 获取班级
    savePerStuInfo: zyurl('/student/perfectInfo/store'), // 完善信息
    addOneFeedback: zyurl('/feedbacks/addOneFeedback'), // 侧边栏 - 意见反馈
    sendMessage: zyurl('/FrontendStudents/sendMessage'),
    removedLog: zyurl('/student/removedLog/last'), // 学生获取被移除班级最新日志
    studentInfo: zyurl('/students/stuInfo'),
    confirgue: zyurl('/confirgue/index'),
    checkAuth: zyurl('/EduYun/check'),
    loginHeart: zyurl('/passport/loginHeart'),
    validate: zyurl('/student/register/valid'),
    register: zyurl('/student/register/store'),
    grade: zyurl('/student/registerDict/grade'),
    validateClassCode: zyurl('/student/register/validateClassCode'),
    authValidateClassCode: zyurl('/student/auth/validateClassCode'),
    authStore: zyurl('/student/auth/store'),
    province: zyurl('/student/registerDict/province'),
    city: zyurl('/student/registerDict/city'),
    district: zyurl('/student/registerDict/district'),
    preDefaultRegion: zyurl('/student/auth/preDefaultRegion'),
    authEnter: zyurl('/student/auth/enter')
  }
}



// WEBPACK FOOTER //
// ./src/api/Api.js